import { Routes } from '@angular/router';

import { authGuard, permissionGuard } from './core/auth.guard';
import {
  companyResourceConfig,
  inventoryResourceConfig,
  projectResourceConfig,
  projectTaskResourceConfig,
  sampleShipmentResourceConfig
} from './features/resource-configs';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login.page').then((m) => m.LoginPage)
  },
  {
    path: 'set-password',
    loadComponent: () => import('./features/set-password.page').then((m) => m.SetPasswordPage)
  },
  {
    path: '',
    loadComponent: () => import('./layout/shell.component').then((m) => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard.page').then((m) => m.DashboardPage)
      },
      {
        path: 'projects/:id',
        loadComponent: () => import('./features/project-workspace.page').then((m) => m.ProjectWorkspacePage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['PROJECT_READ', 'PROJECT_READ_ALL']
        }
      },
      {
        path: 'projects',
        loadComponent: () => import('./features/module-list.page').then((m) => m.ModuleListPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['PROJECT_READ', 'PROJECT_READ_ALL'],
          config: projectResourceConfig
        }
      },
      {
        path: 'tasks/:id',
        loadComponent: () => import('./features/resource-workspace.page').then((m) => m.ResourceWorkspacePage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['PROJECT_TASK_READ', 'PROJECT_TASK_READ_ALL'],
          config: projectTaskResourceConfig,
          detailKind: 'task'
        }
      },
      {
        path: 'tasks',
        loadComponent: () => import('./features/module-list.page').then((m) => m.ModuleListPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['PROJECT_TASK_READ', 'PROJECT_TASK_READ_ALL'],
          config: projectTaskResourceConfig
        }
      },
      {
        path: 'companies/:id',
        loadComponent: () => import('./features/resource-workspace.page').then((m) => m.ResourceWorkspacePage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['COMPANY_READ', 'COMPANY_READ_ALL'],
          config: companyResourceConfig,
          detailKind: 'company'
        }
      },
      {
        path: 'companies',
        loadComponent: () => import('./features/module-list.page').then((m) => m.ModuleListPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['COMPANY_READ', 'COMPANY_READ_ALL'],
          config: companyResourceConfig
        }
      },
      {
        path: 'sample-shipments/:id',
        loadComponent: () => import('./features/resource-workspace.page').then((m) => m.ResourceWorkspacePage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['SAMPLE_SHIPMENT_READ', 'SAMPLE_SHIPMENT_READ_ALL'],
          config: sampleShipmentResourceConfig,
          detailKind: 'shipment'
        }
      },
      {
        path: 'sample-shipments',
        loadComponent: () => import('./features/module-list.page').then((m) => m.ModuleListPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['SAMPLE_SHIPMENT_READ', 'SAMPLE_SHIPMENT_READ_ALL'],
          config: sampleShipmentResourceConfig
        }
      },
      {
        path: 'inventory/:id',
        loadComponent: () => import('./features/inventory-workspace.page').then((m) => m.InventoryWorkspacePage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['INVENTORY_READ', 'INVENTORY_READ_ALL']
        }
      },
      {
        path: 'inventory',
        loadComponent: () => import('./features/module-list.page').then((m) => m.ModuleListPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['INVENTORY_READ', 'INVENTORY_READ_ALL'],
          config: inventoryResourceConfig
        }
      },
      {
        path: 'calendar',
        loadComponent: () => import('./features/calendar.page').then((m) => m.CalendarPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['EVENT_READ_OWN', 'EVENT_READ_INVITED', 'EVENT_READ_PROJECT', 'EVENT_READ_ALL']
        }
      },
      {
        path: 'notifications',
        loadComponent: () => import('./features/notifications.page').then((m) => m.NotificationsPage)
      },
      {
        path: 'forbidden',
        loadComponent: () => import('./features/forbidden.page').then((m) => m.ForbiddenPage)
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile.page').then((m) => m.ProfilePage)
      },
      {
        path: 'admin/users',
        loadComponent: () => import('./features/admin-users.page').then((m) => m.AdminUsersPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['USER_UPDATE_ALL']
        }
      },
      {
        path: 'admin/roles',
        loadComponent: () => import('./features/admin-roles.page').then((m) => m.AdminRolesPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['ROLE_READ']
        }
      },
      {
        path: 'admin/permissions',
        loadComponent: () => import('./features/admin-permissions.page').then((m) => m.AdminPermissionsPage),
        canActivate: [permissionGuard],
        data: {
          permissions: ['ROLE_READ']
        }
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
